<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3 is-flex-vcenter">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-tipo-pedido') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"    
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <div class="form-columns-fit">
            <div class="columns is-flex-column">
                <div class="column">
                    <vs-select
                        :id="generateId(2)"
                        ref="clienteInput"
                        :title="'cliente'"
                        :options="cliente"
                        v-model="clienteTipoPedido.idCliente"
                        :search="loadCliente"
                        :onChange="updateCliente"
                        :placeholder="'cliente'"
                        :invalid="isNull(clienteTipoPedido.idCliente)"
                        :loading="loadingCliente"
                    />
                </div>
                <div class="column">
                    <vs-select
                        :id="generateId(1)"
                        ref="tipoPedidoInput"
                        :title="'tipopedido'"
                        :options="tipoPedidos"
                        v-model="clienteTipoPedido.idTipoPedido"
                        :search="loadTipoPedidos"
                        :onChange="updateTipoPedido"
                        :placeholder="'tipopedido'"
                        :invalid="isNull(clienteTipoPedido.idTipoPedido)"
                        :loading="loadingTipoPedido"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import TipoPedidoService from "@/services/vendas/TipoPedidoService";

// MENSAGENS
import Message from "@/models/Message";

// UTILS
import AssClienteTipoPedidoB2BEmpresaService from '@/services/b2b/AssClienteTipoPedidoB2BEmpresaService';
import ClienteTipoPedidoB2BEmpresaValidation from "@/services/validations/b2b/ClienteTipoPedidoB2BEmpresaValidation";
import { cpfcnpj } from "@/functions/masks";

export default {
    props: {
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            tipoPedidos:[],
            cliente:[],
            loadingTipoPedido: false,
            loadingCliente: false,
            clienteTipoPedido: {
                idCliente: null,
                idTipoPedido: null
            },
            service: new TipoPedidoService(this.$http, this.$router),
            clienteService: new AssClienteTipoPedidoB2BEmpresaService(this.$http, this.$router),
            idproduto: 0,
            isLoading: false,
            validate: null,
            msgs: [],
        }
    },
    created() {
        this.carregarDados();
    },
    methods: {
        carregarDados() {
            this.validation = new ClienteTipoPedidoB2BEmpresaValidation(this.msgs);
        
            this.loadTipoPedidos()
            this.loadCliente()
        },
        save() {
            const lotTemp = this.mapOnSave(this.clienteTipoPedido)
            if (this.validation.validate(lotTemp, this.$refs)) {
                this.isLoading = true;
                this.clienteService
                .save(lotTemp)
                .then(value => {
                    if (!value.content) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(_ => {
                    this.isLoading = false;
                });
            }
        },
        loadTipoPedidos() {
            this.loadingTipoPedido = true;
            this.service
                .findAllCombo()
                .then(this.mapTipoPedidos)
                .then((value) => {
                    this.tipoPedidos = value;
                })
                .catch(e => {
                    console.log(e)
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(_ => {
                    this.loadingTipoPedido = false;
                });
        },
        loadCliente(searchQuery) {
            this.loadingCliente = true;
            this.clienteService
                .findAllCombo(this.$route.params.id, searchQuery)
                .then(this.mapCliente)
                .then((value) => {
                    this.cliente = value;
                })
                .catch((e) => {
                    console.log(e)
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(() => {
                    this.loadingCliente = false;
                });
        },
        updateTipoPedido(idTipoPedido) {
            if (idTipoPedido) {
                this.clienteTipoPedido.idTipoPedido = idTipoPedido;
            } else {
                this.clienteTipoPedido.idTipoPedido = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateCliente(empresa) {
            if (empresa) {
                this.clienteTipoPedido.idCliente = empresa;
            } else {
                this.clienteTipoPedido.idCliente = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        mapTipoPedidos(item) {
            return item.content.map(m => {
                return {
                    id: m.idtipopedido,
                    descricao: m.descricao,
                    label: m.descricao
                };
            });
        },
        mapCliente(item){
            return item.content.map(({ idCliente, cnpjCpf, rsocial, nome, cidade, estado }) => {
                const nomeFormatado = `${cnpjCpf ? cpfcnpj(cnpjCpf) : 'Não informado'} - ${rsocial ? rsocial : nome} - ${cidade ? cidade : 'Não informado'}${estado ? `-${estado}` : ''}`
                
                return {
                    id: idCliente,
                    descricao: nomeFormatado,
                    label: nomeFormatado
                }
            })
        },
        mapOnSave(item){
            return {
                idEmpresa: this.$route.params.id,
                idCliente: item.idCliente.id,
                idTipoPedido: item.idTipoPedido.id
            };
        },
        generateId(numberId){
            return this.$route.name+'-b2b-'+numberId;
        },
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
.bg > #main {
    padding: 20px 20px;

}
</style>